import { useTranslation } from "react-i18next";

import { FilterButton, IOption } from "@digital-services/ui";
import { usePaginationContext } from "@ds-cps/ui";

import { organizationsOptions } from "@organization/models/Organization";
import useGetOrganizationsForFilter from "@organization/services/use-get-organizations-simplified";

import { useResourcesContext } from "../context/useResourcesContext";

export const OwnerFilter = () => {
  const { ownerFilter, setOwnerFilter } = useResourcesContext();
  const { pageIndex, setPageIndex } = usePaginationContext();

  const { t } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  const { organizations, isLoading } = useGetOrganizationsForFilter();

  const ownersOptions = organizations?.length
    ? organizationsOptions(organizations)
    : [];

  return (
    <FilterButton
      data-testid="filter-by-owner"
      singleFilter={true}
      options={ownersOptions}
      selected={ownerFilter ? [ownerFilter] : []}
      enableSearch={true}
      isLoading={isLoading}
      onSelect={(options: IOption[]) => {
        if (options?.length) {
          setOwnerFilter(options[0]);
        } else {
          setOwnerFilter(null);
        }

        // This is to reset pagination when filtering by device type or state happens
        if (pageIndex !== 0) {
          setPageIndex(0);
        }
      }}
    >
      {ownerFilter?.label || t("filters.byOwner")}
    </FilterButton>
  );
};
